import React, { FC } from 'react';
import { getDevEnv } from '../../service/envConfig';
import { getEnvironmentAppUrls } from '@dvag/dfs-constant-config';
import { useParams } from 'react-router-dom';
import { DxContainer, DxSpacer } from '@dvag/design-system-react';
import { useCreateKssElement } from '../../hooks/useCreateKssElement';

export const KundenstammdatenBankverbindungsaenderung: FC = () => {
  const { kundennummer, bankverbindungId } = useParams();

  const env = getDevEnv();
  const appUrls = getEnvironmentAppUrls(env);
  const scriptSrc = `${appUrls.kundenstammdaten}/bankverbindungsaenderung/main.js`;
  const mfeBridgeIdentifier = 'kundenstammdaten-bankverbindungsaenderung';

  const elementParams = {
    scriptSrc,
    querySelector: 'dvag-kundenstammdaten-bankverbindungsaenderung',
    createElementParams: {
      mfeBridgeIdentifier,
      kundennummer,
      bankverbindungId,
    },
  };

  const kssChangeBankDetails = useCreateKssElement(elementParams);

  return (
    <DxContainer
      type="page"
      color="transparent"
      data-testid="bank-details-change-container"
      id="bank-details-change-container"
    >
      <DxSpacer size="32v" />
      {kssChangeBankDetails}
    </DxContainer>
  );
};
